import { isWeb } from 'APP/Helpers/checkPlatform'

export default {
  welcomeSlide0: isWeb()
    ? require('APP/Videos/welcomeSlide0.web.mp4')
    : require('APP/Videos/welcomeSlide0.mp4'),
}
